module.exports = __webpack_public_path__ + "img/lighting_and_visibility.37983eac.svg";